import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import { useHistory } from 'react-router-dom';
import { Tab } from 'semantic-ui-react';
import isParentOrganization from 'helpers/isParentOrganization';
import OrganizationWallet from './OrganizationWallet';
import GroupWallet from './GroupWallet';
import IndividualWallet from './IndividualWallet';

const panes = props => [
  {
    menuItem: 'Organization wallets',
    render: () => <OrganizationWallet props={props} />,
  },
  {
    menuItem: 'Group wallets',
    render: () => <GroupWallet props={props} />,
  },
  {
    menuItem: 'Individual wallets',
    render: () => <IndividualWallet props={props} />,
  },
];

const Wallet = ({ location, history, match }) => {
  const { push } = useHistory();
  const isCurrentOrgParent = isParentOrganization();

  const tabs = {
    organization: { index: 0, name: 'organization' },
    group: { index: 1, name: 'group' },
    individual: { index: 2, name: 'individual' },
  };

  const {
    params: { tab },
  } = match;

  const activeIndex = !tabs[tab] ? 0 : tabs[tab].index;

  const handleTabChange = (_e, { activeIndex }) => {
    const key = Object.keys(tabs).find(
      key => tabs[key].index === activeIndex,
    );
    push(`/wallets/${key}`);
  };

  if (!isCurrentOrgParent) {
    return (
      <OrganizationWallet props={{ location, history, match }} />
    );
  }

  return (
    <div className="wallet-tab-items">
      <Tab
        activeIndex={activeIndex}
        menu={{ secondary: true, pointing: true }}
        panes={panes({ location, history, match })}
        onTabChange={handleTabChange}
      />
    </div>
  );
};

Wallet.propTypes = {
  location: PropTypes.objectOf(Object).isRequired,
  history: PropTypes.objectOf(Object).isRequired,
  match: PropTypes.shape({
    params: PropTypes.oneOfType([PropTypes.object]),
  }).isRequired,
};

export default Wallet;
